import "./PushNotification.scss";
import React, { useContext } from "react";
import AlertContext from "./context/AlertContext";
import useAxiosPrivate from "./Hooks/useAxiosPrivate";
import useCommonFunctionHooks from "./Hooks/useCommonFunctionHooks";

export default function PushNotification() {
  const Alert = useContext(AlertContext);

  const axios = useAxiosPrivate();
  const useCommonFunctionHks = useCommonFunctionHooks();

  const jwtToken = Alert.notificationPayload?.data?.data?.jwtToken;

  const date =
    Alert.notificationPayload?.data?.notification?.body.split("\n")[0];

  const time =
    Alert.notificationPayload?.data?.notification?.body.split("\n")[1];

  const body =
    Alert.notificationPayload?.data?.notification?.body.split("\n")[2];

  const requestData = {
    jwtToken: jwtToken,
  };

  const markAsPresent = async () => {
    try {
      const response = await axios.put(
        `node/learner/attendance/record/${1}`,
        requestData,
        useCommonFunctionHks.getHeaderDetailsForAxios()
      );

      Alert.setNotificationPayload({
        ...Alert.notificationPayload,
        open: false,
      });

      if (response.data?.message === "token expired") {
        Alert.setNotificationPayload({
          open: true,
          msg: `As you didn't mark attendance within the time limit,\nYour attendance is recorded as Absent.`,
        });
      } else {
        Alert.setNotificationPayload({
          open: true,
          msg: "Your attendance is recorded as present.",
        });
        Alert.setShowBlink(false);
      }
    } catch (err) {
      Alert.setNotificationPayload({
        ...Alert.notificationPayload,
        open: false,
      });

      useCommonFunctionHks.getCatchBlockDetails(err);
    }
  };

  const markAsAbsent = async () => {
    try {
      const response = await axios.put(
        `node/learner/attendance/record/${2}`,
        requestData,
        useCommonFunctionHks.getHeaderDetailsForAxios()
      );

      Alert.setNotificationPayload({
        ...Alert.notificationPayload,
        open: false,
      });

      if (response.data?.message === "token expired") {
        Alert.setNotificationPayload({
          open: true,
          msg: `As you didn't mark attendance within the time limit,\nYour attendance is recorded as Absent.`,
        });
      } else {
        Alert.setNotificationPayload({
          open: true,
          msg: "Your attendance is recorded as Absent.",
        });
        Alert.setShowBlink(false);
      }
    } catch (err) {
      Alert.setNotificationPayload({
        ...Alert.notificationPayload,
        open: false,
      });

      useCommonFunctionHks.getCatchBlockDetails(err);
    }
  };

  return (
    <div
      className={
        Alert.notificationPayload?.msg ===
        "Your attendance is recorded as present."
          ? "notificationforpresent"
          : "notification"
      }
    >
      <div className="notifyBody">
        <p className="notifyPara">Attendance</p>
        {Alert.notificationPayload?.data?.notification?.title && (
          <h5 className="notifyHeading">
            {
              Alert.notificationPayload?.data?.notification?.title.split(
                "\n"
              )[1]
            }
          </h5>
        )}
        {Alert.notificationPayload?.msg && (
          <button
            className="close-button"
            onClick={() =>
              Alert.setNotificationPayload({
                ...Alert.notificationPayload,
                open: false,
              })
            }
          >
            X
          </button>
        )}

        {Alert.notificationPayload?.data && (
          <>
            <p className="notifyPara">{date}</p>
            <p className="notifyPara">{time}</p>
            <p className="notifyPara">{body}</p>
          </>
        )}
      </div>

      {Alert.notificationPayload?.data && (
        <div className="responseButtons">
          <button className="btnSmallPresent" onClick={markAsPresent}>
            Present
          </button>
          <button className="btnSmallAbsent" onClick={markAsAbsent}>
            Absent
          </button>
          <button
            className="btnSmallIgnore"
            onClick={() =>
              Alert.setNotificationPayload({
                ...Alert.notificationPayload,
                open: false,
              })
            }
          >
            Ignore
          </button>
        </div>
      )}

      {Alert.notificationPayload?.msg && (
        <p className="markMessage"> {Alert.notificationPayload.msg}</p>
      )}
    </div>
  );
}
